// The owning company's people on this project, with the Executive mark
// (owner brief 2026-10-11 T43) and each person's job title (T44).
//
// Executive: who receives the weekly progress and the monthly executive copy.
// Set by the project owner or a company administrator. Job title: a label
// only - it changes no access and no email - set by the company's own
// administrator. The server decides who may change which (canSet* flags);
// this card only shows the controls it was told the viewer may use.
import React, { useCallback, useEffect, useState } from "react";
import { Select, Switch, Tag, Tooltip, message } from "antd";
import { getRosterMarks, setOwnerRosterMark } from "api/participants/participantsApi";

export default function OwnerTeamCard({ projectId, onJobTitles }) {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState("");

  const load = useCallback(() => {
    getRosterMarks(projectId)
      .then((res) => {
        setData(res);
        if (onJobTitles) onJobTitles(res.jobTitles || []);
      })
      .catch(() => setData(null));
  }, [projectId, onJobTitles]);

  useEffect(() => { load(); }, [load]);

  const save = async (userId, body) => {
    setSaving(userId);
    try {
      await setOwnerRosterMark(projectId, userId, body);
      load();
    } catch (e) {
      message.error(e.message || "Could not save");
    } finally {
      setSaving("");
    }
  };

  if (!data || !(data.members || []).length) return null;
  const titleOptions = (data.jobTitles || []).map((t) => ({ value: t, label: t }));
  return (
    <div style={{ border: "1px solid #eee", borderRadius: 8, padding: "10px 14px", marginBottom: 16 }}>
      <div style={{ fontWeight: 600, marginBottom: 6 }}>Project team (owning company)</div>
      {data.members.map((m) => (
        <div key={m.userId} style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", fontSize: 12, padding: "3px 0" }}>
          <b>{m.name}</b>
          <span style={{ color: "#888" }}>{m.email}</span>
          {m.isProjectOwner && <Tag color="green" style={{ fontSize: 10, lineHeight: "16px" }}>Project owner</Tag>}
          <span style={{ flex: 1 }} />
          {data.canSetOwnerJobTitles ? (
            <Select
              size="small"
              allowClear
              placeholder="Job title"
              style={{ width: 150 }}
              value={m.jobTitle || undefined}
              options={titleOptions}
              disabled={saving === m.userId}
              onChange={(v) => save(m.userId, { jobTitle: v || "" })}
            />
          ) : (
            m.jobTitle ? <Tag style={{ fontSize: 10, lineHeight: "16px" }}>{m.jobTitle}</Tag> : null
          )}
          <Tooltip title="Receives the weekly progress and the monthly executive report for this project.">
            <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
              <Switch
                size="small"
                checked={!!m.isExecutive}
                disabled={!data.canSetExecutive}
                loading={saving === m.userId}
                onChange={(on) => save(m.userId, { isExecutive: on })}
              />
              <span style={{ color: "#667085" }}>Executive</span>
            </span>
          </Tooltip>
        </div>
      ))}
    </div>
  );
}
